import type { StatusTone } from '@/ui/primitives/Chip';
import type { PlanCode } from '@flowqa/shared';

export const getPlanChipTone = (planCode: PlanCode | null | undefined): StatusTone => {
  switch (planCode) {
    case 'solo':
      return 'purple';
    case 'team':
      return 'pink';
    case 'trial':
    case null:
    case undefined:
      return 'default';
  }
};
